import { render, staticRenderFns } from "./Placement_Groups.vue?vue&type=template&id=33701e38&scoped=true"
import script from "./Placement_Groups.vue?vue&type=script&lang=js"
export * from "./Placement_Groups.vue?vue&type=script&lang=js"
import style0 from "./Placement_Groups.vue?vue&type=style&index=0&id=33701e38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33701e38",
  null
  
)

export default component.exports